import * as homeAction from './action';

const initialState = {
    redirectToPortfolio: []
}

const homeReducer = (state = initialState, action) => {
    switch (action.type) {

        case homeAction.REDIRECT_TO_PORTFOLIO:
            return state = {
                ...state,
                redirectToPortfolio: action.data
            }
        default: return state
    }
}

export default homeReducer;